import Vue from 'vue';
import Router from 'vue-router';
import documentTitle from '@/lib/documentTitle';
import loginRequired from '@/lib/loginRequired';

import Index from './views/Index.vue';
import Contact from './views/Contact.vue';
import Projects from './views/Projects.vue';
import Journal from './views/Journal.vue';

import Maintenance from './views/Maintenance.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

const main = new Router({
 mode: 'history',
 base: process.env.BASE_URL,
 routes: [
  { path:'/', name:'index', component:Index, meta:{ title:"The portfolio and journal of Michael Largent" } },
  { path:'/contact', name:'contact', component:Contact, meta:{ title:"Contact Me" } },
  { path:'/projects', name:'projects', component:Projects, meta:{ title:"Projects" } },
  { path:'/journal', name:'journal', component:Journal, meta:{ title:"Journal" }, redirect:'/maintenance' },

  { path:'/maintenance', name:'Maintenance', component:Maintenance, meta:{ title:"Maintenance" } },
  { path:'*', name:'notfound', component:NotFound, meta:{ title:"Not Found" }}
 ]
});
main.beforeEach( (to,from,next)=> loginRequired(to,next,'/login') );
main.afterEach( to => documentTitle(to,'Simple Mike') );

export default main;